<script setup>
import { computed } from 'vue';
import UiDialog from './UiDialog.vue';
import { useConfirm } from '@/composables/useConfirm';

// shadcn AlertDialog: rendered once in the shell; pages call
// `await useConfirm().confirm({...})`. No close button and no outside-click
// dismissal: the user picks Cancel or the action (Esc cancels).
const { state, accept, cancel } = useConfirm();

const open = computed({
  get: () => state.open,
  set: (value) => {
    if (!value) cancel();
  },
});
</script>

<template>
  <UiDialog
    v-model="open"
    :title="state.title"
    :description="state.description"
    size="md"
    hide-close
  >
    <template #footer>
      <v-btn variant="outlined" @click="cancel">{{ state.cancelText }}</v-btn>
      <v-btn :color="state.destructive ? 'error' : 'primary'" @click="accept">
        {{ state.confirmText }}
      </v-btn>
    </template>
  </UiDialog>
</template>
